export const homeAdvantages = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    titleKey: "advantages.security.title",
    descKey: "advantages.security.desc",
  },
  {
    id: 2,
    icon: "ri-scales-3-line",
    titleKey: "advantages.fairness.title",
    descKey: "advantages.fairness.desc",
  },
  {
    id: 3,
    icon: "ri-stack-line",
    titleKey: "advantages.diversity.title",
    descKey: "advantages.diversity.desc",
  },
  {
    id: 4,
    icon: "ri-customer-service-2-line",
    titleKey: "advantages.service.title",
    descKey: "advantages.service.desc",
  },
  {
    id: 5,
    icon: "ri-flashlight-line",
    titleKey: "advantages.speed.title",
    descKey: "advantages.speed.desc",
  },
  {
    id: 6,
    icon: "ri-gift-2-line",
    titleKey: "advantages.bonus.title",
    descKey: "advantages.bonus.desc",
  },
];

export const membershipTiers = [
  {
    id: 1,
    nameKey: "membership.bronze",
    color: "bg-secondary-400",
    textColor: "text-secondary-700",
    borderColor: "border-secondary-300",
    benefits: ["新会员注册即享", "每日签到奖励", "基础客服支持", "参与常规活动"],
    minLevel: 0,
  },
  {
    id: 2,
    nameKey: "membership.silver",
    color: "bg-secondary-500",
    textColor: "text-secondary-800",
    borderColor: "border-secondary-400",
    benefits: ["专属晋级礼包", "优先客服通道", "月度回馈活动", "更高返利比例", "生日专属福利"],
    minLevel: 100,
  },
  {
    id: 3,
    nameKey: "membership.gold",
    color: "bg-accent-400",
    textColor: "text-accent-800",
    borderColor: "border-accent-300",
    benefits: ["黄金专属标识", "VIP专属客服经理", "每周专属活动", "更高提现额度", "专属节日礼遇", "优先参与内测"],
    minLevel: 500,
  },
  {
    id: 4,
    nameKey: "membership.platinum",
    color: "bg-accent-500",
    textColor: "text-accent-900",
    borderColor: "border-accent-400",
    benefits: ["铂金专属标识", "1对1专属管家", "定制化服务方案", "最高返利比例", "线下活动邀请", "专属理财顾问", "优先体验新功能"],
    minLevel: 2000,
  },
  {
    id: 5,
    nameKey: "membership.diamond",
    color: "bg-primary-500",
    textColor: "text-primary-800",
    borderColor: "border-primary-300",
    benefits: ["钻石至尊标识", "全球贵宾礼遇", "私人定制服务", "无限提现额度", "全球线下盛宴", "专属投资机会", "家族账号共享", "终身荣誉会员"],
    minLevel: 10000,
  },
];

export const homePromotions = [
  {
    id: 1,
    title: "新会员首存豪礼",
    description: "首次存款享受100%加赠，最高可获赠8888元礼金，让您的旅程从一开始就精彩纷呈。",
    tag: "限时",
    tagColor: "bg-primary-500",
    imageSeq: "promo-new-member",
  },
  {
    id: 2,
    title: "每日签到领好礼",
    description: "连续签到7天即可获得额外奖励，坚持打卡，惊喜不断，积分可兑换丰富奖品。",
    tag: "每日",
    tagColor: "bg-accent-500",
    imageSeq: "promo-daily",
  },
  {
    id: 3,
    title: "邀请好友共赢",
    description: "邀请好友注册并完成首存，双方均可获得专属奖励，好友越多，奖励越丰厚。",
    tag: "热门",
    tagColor: "bg-primary-500",
    imageSeq: "promo-referral",
  },
];